import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./TutorialLink.module.scss";

const TutorialLink = ({ href }) => {
  const { t } = useTranslation();

  return (
    <a
      className={styles.link}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("Watch tutorial")}
      data-tooltip={t("Watch tutorial")}
    >
      <span className="material-icons" aria-hidden="true">play_circle</span>
    </a>
  );
};

export default TutorialLink;
